import { useProductsTabContext } from "./explorerProductsTab";
import { useSuppliersTabContext } from "./explorerSuppliersTab";
import { useCustomersTabContext } from "./explorerCustomersTab";

export const derivePendingGateActivity = ({
  productsSummary,
  pendingBomRequests,
  suppliersSummary,
  customersSummary
}) => ({
  products:
    (productsSummary?.count || 0) > 0 ||
    (pendingBomRequests?.length || 0) > 0 ||
    (productsSummary?.receivedBomRequestsCount || 0) > 0,
  suppliers:
    (suppliersSummary?.pendingSharesCount || 0) > 0 ||
    (suppliersSummary?.confirmedSharesCount || 0) > 0 ||
    (suppliersSummary?.revokedSharesCount || 0) > 0 ||
    (suppliersSummary?.receivedProductsCount || 0) > 0,
  customers:
    (customersSummary?.pendingIncomingCount || 0) > 0 ||
    (customersSummary?.pendingOutgoingShareCount || 0) > 0 ||
    (customersSummary?.acceptedCount || 0) > 0 ||
    (customersSummary?.revokedCount || 0) > 0 ||
    (customersSummary?.legacyInvitedCount || 0) > 0
});

export const usePendingGateActivity = () => {
  const { productsSummary, pendingBomRequests, customers } =
    useProductsTabContext();
  const { suppliersSummary } = useSuppliersTabContext();
  const { customersSummary } = useCustomersTabContext(customers);

  return derivePendingGateActivity({
    productsSummary,
    pendingBomRequests,
    suppliersSummary,
    customersSummary
  });
};
